import ImageDrawer from "../../components/Inpainting/ImageDrawer.component";

const InPaintingPage = () => {
    return (
        <div className="route">
            <h1>Inpainting</h1>
            <ImageDrawer />
        </div>
    );
};

export default InPaintingPage;
